/* eslint-disable no-useless-constructor */
export class ThongTinDatVe {
    maLichChieu = 0;
    danhSachVe = []
    constructor() {

    }
}


// {
//     "maLichChieu": 0,
//     "danhSachVe": [
//       {
//         "maGhe": 0,
//         "giaVe": 0
//       }
//     ]
//   }